import React, { useEffect, useState, useRef } from 'react';
import "./ScheduleCreate.scss";
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { useSelector, useDispatch } from 'react-redux';

const ScheduleCreate = ({ handleClick }) => {

    return (
        <div className="schedule-create">
            <div className="schedule-confirm__button confirm">
                <button className="g-button" onClick={handleClick}>
                    <span>Создать график</span>
                </button>
            </div>
        </div>
    );
};

export default ScheduleCreate;